module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Outer', [_c('div', {
    staticClass: "row mt10"
  }, [(_vm.video && _vm.video.poster && _vm.video.poster.url && _vm.video.tank && _vm.video.tank.url) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('NbVideo', {
    attrs: {
      "video": _vm.video
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "mv10"
  }, [_c('NbTank', {
    attrs: {
      "tank": _vm.video.tank,
      "edit": false
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.video.description)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-a95c759a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/video/Detail.vue
// module id = 1015
// module chunks = 1